
import axios from "axios";

export const state = {
    staffadvances: [],
};

export const getters = {
    staffadvances: state => state.staffadvances,
};

export const mutations = {
    setStaffAdvances(state, newValue) {
        state.staffadvances = newValue
    },
};

export const actions = {
    fetchStaffAdvances({ commit }) {
        axios.get('/staffadvances').then(res => {
            commit('setStaffAdvances', res.data.staffadvances);
        })
    },
};
